import React from 'react';
import { Route } from 'react-router-dom';

import CodeFlowCallback from 'pages/login/CodeFlowCallback';
import LoginPage from 'pages/login/Login';
import Logout from 'pages/logout/Logout';

import { AUTH_ROUTES } from './constants/auth-routes.constant';

export const useAuthRouter = (): React.JSX.Element => (
  <>
    <Route path={AUTH_ROUTES.LOGIN} element={<LoginPage />} />
    <Route
      path={AUTH_ROUTES.CODE_FLOW_CALLBACK}
      element={<CodeFlowCallback />}
    />
    <Route path={AUTH_ROUTES.LOGOUT} element={<Logout />} />
  </>
);
